<template>
    <div class="flex flex-col relative" :class="customClass">
      <input
        :type="type"
        v-model="valueProxy"
        :placeholder="label"
        :readonly="readonly"
        :maxlength="maxlength"
        :class="['form-input w-full', error ? 'border-red-500' : '']"
        :required="required"
        @blur="$emit('blur')"
      >
      <div v-if="error" class="form-error">{{ errorMessage }}</div>
    </div>
  </template>
  <script>
  export default {
    props: {
      value: [String, Number],
      label: String,
      type: { type: String, default: 'text' },
      error: Boolean,
      errorMessage: String,
      required: Boolean,
      readonly: Boolean,
      maxlength: Number,
      customClass: String
    },
    computed: {
      valueProxy: {
        get() { return this.value; },
        set(val) { this.$emit('input', val); }
      }
    }
  }
  </script>
  